<template>
  <div class="pgm-payroll">
    <v-card>
      <v-card-text>
    <div class="payroll-tabs-wrapper">
      <div class="tabs-header-container">
        <v-tabs v-model="activeTab" class="payroll-tabs">
          <v-tab value="staff" class="payroll-tab">
            <v-icon class="tab-icon">mdi-account-tie</v-icon>
            <span class="tab-text">센터장・사회복지사 급여</span>
          </v-tab>
          <v-tab value="yobo" class="payroll-tab">
            <v-icon class="tab-icon">mdi-account-group</v-icon>
            <span class="tab-text">요양보호사 급여</span>
          </v-tab>
        </v-tabs>
        <div class="tab-magam-btn">
          <MagamBtn 
            :groupedMemberData="yoboData"
            :lebYm="yoboLebYm"
            :taxData="yoboTaxData"
            :settingsData="yoboSettingsData"
            :sabokStaffData="sabokStaffData"
            :sabokStaffSettings="sabokStaffSettings"
            @magamStatusChanged="handleMagamStatusChanged"
          />
        </div>
      </div>
    </div>
    <div class="payroll-window">
      <div v-show="activeTab === 'staff'">
        <TabSabokWage ref="tabSabokWageRef" :isMagam="isMagam" />
      </div>
      <div v-show="activeTab === 'yobo'">
        <TabYoboWage ref="tabYoboWageRef" :sabok-staff-data="sabokStaffData" :sabok-staff-settings="sabokStaffSettings" :isMagam="isMagam" />
      </div>
    </div>
    </v-card-text>
  </v-card>
  </div>
</template>

<script setup lang="ts">
import TabYoboWage from "@/components/wage/TabYoboWage.vue";
import TabSabokWage from "@/components/wage/TabSabokWage.vue";
import MagamBtn from "@/components/wage/MagamBtn.vue";
import { ref, computed, watch, nextTick, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const route = useRoute();
const store = useStore();

const activeTab = ref<string>("yobo");
const tabSabokWageRef = ref<any>(null);
const tabYoboWageRef = ref<any>(null);

// 마감 상태
const isMagam = ref(false);

// 마감 상태 변경 핸들러
const handleMagamStatusChanged = (status: boolean) => {
  isMagam.value = status;
};

// TabSabokWage의 데이터를 computed로 가져오기
const sabokStaffData = computed(() => {
  if (!tabSabokWageRef.value) return [];
  return tabSabokWageRef.value.staffData || [];
});

const sabokStaffSettings = computed(() => {
  if (!tabSabokWageRef.value) return {};
  return tabSabokWageRef.value.staffSettings || {};
});

// TabYoboWage의 데이터를 computed로 가져오기 (마감 버튼용)
const yoboData = computed(() => {
  if (!tabYoboWageRef.value) return [];
  return tabYoboWageRef.value.groupedMemberData || [];
});

const yoboLebYm = computed(() => {
  if (!tabYoboWageRef.value) return '';
  return tabYoboWageRef.value.lebYm || '';
});

const yoboTaxData = computed(() => {
  if (!tabYoboWageRef.value) return null;
  return tabYoboWageRef.value.taxData || null;
});

const yoboSettingsData = computed(() => {
  if (!tabYoboWageRef.value) return [];
  return tabYoboWageRef.value.settingsData || [];
});

// 쿼리 파라미터에서 연도와 월을 읽어서 YearMonthSelector에 설정
onMounted(() => {
  const year = route.query.year as string;
  const month = route.query.month as string;
  
  if (year && month) {
    // YYYYMM 형식으로 변환
    const yearMonth = `${year}${month.padStart(2, '0')}`;
    // store에 설정하여 TabYoboWage와 TabSabokWage의 YearMonthSelector가 자동으로 업데이트되도록 함
    store.commit('setLebYm', yearMonth);
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/pgmWage.scss";
</style>
